<template>
  <div
    class="bg-color-white catalog-search"
    :class="{
      'catalog-search__perform': catalog === 'perform' || catalog === 'authors',
    }"
  >
    <div class="row">
      <div class="col-12">
        <div class="catalog-search__select" v-if="catalog === 'shop'">
          <button
            class="select type-circular align-left"
            @click="toggleDropdown"
          >
            <span>Explore More Shops</span>
            <div
              class="select-carat bg-color-primary"
              :class="dropdownOpen ? 'active' : ''"
            ></div>
          </button>
          <button
            class="catalog-search__reset type-small"
            @click="clearCatalog"
            v-if="activeCategory.Id !== 0"
          >
            View all
          </button>

          <div
            class="catalog-search__dropdown bg-color-white"
            :class="dropdownOpen ? 'active' : ''"
          >
            <div
              class="catalog-search__featured add-large-bottom-margin"
              v-if="featuredCollections.length > 0"
            >
              <p class="color-primary type-h4 add-bottom-margin">Highlights</p>
              <ul class="unstyled-list">
                <li
                  class="type-regular"
                  v-for="item in searchBarFeaturedCollections"
                >
                  <a
                    href="#"
                    :data-id="item.Id"
                    key="item.Id"
                    @click.prevent="handleChange"
                    :class="collectionColor(item)"
                  >
                    {{ item.Name }}
                    <span v-show="getCollectionTotal(item) > 0"
                      >({{ getCollectionTotal(item) }})</span
                    >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="catalog-filters hide-medium-up">
          <CatalogSearchField :catalog="catalog" />
        </div>

        <div class="catalog-search__misc bg-color-silver-lightest">
          <CatalogCurrentView :catalog="catalog" />

          <div class="flex flex--align-center flex--between width-100">
            <div
              class="flex flex--align-center catalog-search__sort"
              v-if="catalog !== 'authors'"
            >
              <label
                for="orderby"
                class="type-small catalog-search__sort-label color-silver"
                >Sort by</label
              >
              <select
                name="orderby"
                id="orderby"
                v-model="orderBy"
                @change="handleSort"
                class="select-plain"
              >
                <option value="DisplayOrder">Featured</option>
                <option value="AlphaByAuthor">Author</option>
                <option value="AlphaByTitle">Title</option>
              </select>
            </div>
            <div
              class="catalog-search__display no-line-height"
              v-if="catalog !== 'authors'"
            >
              <button
                @click="setListDisplay"
                :class="display == 'list' ? 'active' : ''"
                title="List view"
              >
                <span class="sr">Display results as list</span>
                <img src="/images/icon-list.svg" alt="list" />
              </button>
              <button
                @click="setGridDisplay"
                :class="display == 'grid' ? 'active' : ''"
                title="Grid view"
              >
                <span class="sr">Display results as grid</span>
                <img src="/images/icon-grid.svg" alt="grid" />
              </button>
            </div>
          </div>
        </div>

        <button
          class="btn btn--tertiary btn--full btn--small btn--arrow show-small add-top-margin"
          v-if="catalog !== 'authors'"
          @click="toggleFilters"
        >
          {{ filterButtonText }}
          <span
            v-if="activeFilterCount > 0"
            class="bg-color-primary color-white badge type-bold"
            >{{ activeFilterCount }}</span
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  GET_FILTERED_ITEMS,
  GET_FILTERED_AUTHORS,
  SET_CATALOG_LOCALSTORAGE,
} from "../vuex/modules/catalog/mutations";

import CatalogCurrentView from "./CatalogCurrentView.vue";
import CatalogSearchField from "./CatalogSearchField.vue";

export default {
  name: "CatalogSearch",
  props: ["catalog"],
  components: {
    CatalogCurrentView,
    CatalogSearchField,
  },
  data() {
    return {
      orderBy: "DisplayOrder",
      currentCollection: 0,
      everythingOptionName: "",
      // selectedCatalogCollections: [],
      dropdownOpen: false,
      queryParamCatalog: "",
    };
  },
  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let sortBy = urlParams.get("sortBy") || "DisplayOrder";
    let pageNum = urlParams.get("pageNumber");
    let author = urlParams.get("author");
    let attrId = urlParams.get("attrId");
    let attrName = urlParams.get("attrName");
    pageNum = pageNum != null ? parseInt(pageNum) : 0;
    this.$store.commit("setPageNumber", pageNum + 1);
    this.$store.commit("setAuthor", author);
    this.$store.commit("setOrder", sortBy);
    this.orderBy = sortBy;

    if (attrId && attrName) {
      sessionStorage.removeItem("performStore");
      this.$store.commit("clearActiveAttributes");
      this.$store.commit("setActiveAttributes", {
        Id: attrId,
        Name: attrName,
        Excludable: false,
        TotalProducts: 0,
        OptionId: attrId,
      });
      this.setLocalStorage();
    }
  },
  mounted() {
    this.everythingOptionName =
      this.catalog == "authors" ? "All" : "Everything";
    this.setInitialGridDisplay();
  },
  methods: {
    ...mapActions({
      GET_FILTERED_ITEMS,
      GET_FILTERED_AUTHORS,
      SET_CATALOG_LOCALSTORAGE,
    }),

    setInitialGridDisplay() {
      this.setGridDisplay();
    },

    handleSort($event) {
      const val = $event.target.value;

      this.$store.commit("setOrder", val);

      this.getFilteredResults();
    },

    clearCatalog() {
      this.$store.commit("setActiveCategory", { id: 0 });
      this.$store.commit("setPageNumber", this.currentPage);
      this.dropdownOpen = false;
      // this.updateUrl(0);
      this.getFilteredResults();
      this.setLocalStorage();
    },

    getFilteredResults() {
      const action =
        this.catalog == "authors"
          ? "GET_FILTERED_AUTHORS"
          : "GET_FILTERED_ITEMS";
      this[action]()
        .then(() => {
          this.$store.commit("buildNextLinks", this.totalPages);
          this.$store.commit("buildPrevLinks");
        })
        .then(() => {
          this.setLocalStorage();
        });
    },

    // updateUrl(id) {
    //   const currentUrl = `${location.protocol}//${location.host}${location.pathname}`;
    //   const updated = id == 0 ? currentUrl : `${currentUrl}?catalogId=${id}`;
    //   history.pushState({
    //     catalogId: id
    //   }, 'Catalog | Concord',updated);
    //   // console.log('update url', id);
    // },

    setLocalStorage() {
      this.SET_CATALOG_LOCALSTORAGE();
    },

    handleChange($event) {
      const val = $event.target.dataset.id;
      const name = $event.target.innerText;

      this.$store.commit("setActiveCategory", { id: val, name: name });
      this.$store.commit("setPageNumber", this.currentPage);

      //  window.history.pushState({path:newurl},'',newurl);
      // this.updateUrl(val);
      this.toggleDropdown();
      this.getFilteredResults();
    },

    toggleFilters() {
      const visibility = !this.filtersVisible;
      this.$store.commit("setFiltersVisiblity", visibility);
    },

    setGridDisplay() {
      this.$store.commit("setDisplayMode", "grid");
    },

    setListDisplay() {
      this.$store.commit("setDisplayMode", "list");
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    getTotalProductsInCollection(collection) {
      return collection.map((item) => {
        const match = this.filteredCategories.find((cat) => {
          return cat.Id == item.Id;
        });
        if (match) {
          return {
            Id: match.Id,
            Name: match.Name,
            TotalProducts: match.TotalProducts,
          };
        } else {
          return {
            Id: item.Id,
            Name: item.Name,
            TotalProducts: 0, //(this.activeCategory.Id == item.Id ) ? this.TotalResults : 0,
          };
        }
      });
    },

    collectionColor(item) {
      if (this.activeCategory.Id == item.Id) {
        return "type-bold color-off-black";
      }

      if (item.TotalProducts < 1) {
        return "color-off-black";
      }

      return "color-silver-darkest type-link";
    },

    getCollectionTotal(collection) {
      return this.activeCategory.Id == collection.Id
        ? this.totalProducts
        : collection.TotalProducts;
    },
  },

  computed: {
    ...mapState({
      authors: (state) => state.catalogStore.authors,
      collections: (state) => state.catalogStore.collections,
      currentPage: (state) => state.catalogStore.currentPage,
      activeCategory: (state) => state.catalogStore.activeCategory,
      filteredCategories: (state) => state.catalogStore.filteredCategories,
      // activeCategoryName: state => state.catalogStore.activeCategoryName,
      searchTerm: (state) => state.catalogStore.searchTerm,
      totalProducts: (state) => state.catalogStore.totalProducts,
      display: (state) => state.catalogStore.display,
      selectedCatalogCollections: (state) =>
        state.catalogStore.selectedCatalogCollections,
      filtersVisible: (state) => state.catalogStore.filtersVisible,
      locale: (state) => state.catalogStore.locale,
      // totalVisible: state => state.catalogStore.totalVisible,
    }),

    ...mapGetters([
      "availableCategories",
      "currentCollectionDescription",
      "totalVisible",
      "totalPages",
      "authorCollections",
      "performCollections",
      "shopCollections",
      "activeFilterCount",
      "filterButtonText",
    ]),

    // ...mapGetters
    // NOTE: also exists in Catalog hero, needed to be refactored
    currentCollectionName() {
      return this.activeCategory.Name !==
        (this.locale == "UK"
          ? "The Concord Theatricals Catalogue"
          : "The Concord Theatricals Catalog")
        ? this.activeCategory.Name
        : "";
    },

    totalResults() {
      const obj = this.collections.find(
        (option) => option.Id == this.currentCollection
      );
      return typeof obj !== "undefined"
        ? obj.TotalProducts
        : this.totalProducts;
    },

    formattedSearchTerm() {
      return this.searchTerm !== "" ? `/${this.searchTerm}` : "";
    },

    featuredCollections() {
      const collection = this.selectedCatalogCollections
        .filter((collection) => {
          return (
            collection.Featured == true &&
            collection.Searchable == true &&
            collection.CategoryTypes.includes("Widget") == false
          );
        })
        .slice(0, 4);

      // this method return the same collections, but with
      // only the needed data to display, including how many
      // products it has.

      return this.getTotalProductsInCollection(collection);
    },

    searchBarFeaturedCollections() {
      const collection = this.shopCollections.filter((collection) => {
        return (
          collection.Featured == true &&
          collection.Searchable == true &&
          collection.CategoryTypes.includes("Widget") == false
        );
      });
      const featuredList = _.orderBy(
        this.getTotalProductsInCollection(collection),
        function(e) {
          return e.Name;
        }
      );
      return featuredList;
    },

    resultsLabel() {
      return this.totalResults > 1 || this.totalResults == 0
        ? "Results"
        : "Result";
    },

    /**
     * Generates an array of collection objects to display in the "popular" area.
     * Filters out "featured" and anything tagged as for widgets. Sorts alpha
     * and limits to 12 items.
     */
    popularCollections() {
      const collection = this.selectedCatalogCollections
        .filter((collection) => {
          return (
            collection.Featured == false &&
            collection.Searchable == true &&
            collection.CategoryTypes.includes("Widget") == false
          );
        })
        .sort((a, b) => {
          // sort alphabetically
          return a.Name.localeCompare(b.Name);
        })
        .slice(0, 12);

      // this method return the same collections, but with
      // only the needed data to display, including how many
      // products it has.
      return this.getTotalProductsInCollection(collection);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogSearch.vue